import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const API_REPORTS_BASE = "/admin/reports";

const toNumberArray = (value) =>
  (Array.isArray(value) ? value : [])
    .map((item) => Number(item))
    .filter((item) => Number.isFinite(item) && item > 0);

const normalizeFullReportPayload = (payload) => ({
  type: "Full",
  transaction_type: (Array.isArray(payload?.transaction_type)
    ? payload.transaction_type
    : [payload?.transaction_type]
  )
    .map((item) => String(item ?? "").trim().toUpperCase())
    .filter(Boolean),
  from: Number(payload?.from),
  to: Number(payload?.to),
  ibs: toNumberArray(payload?.ibs),
  trees: toNumberArray(payload?.trees),
});

export async function generateReport(payload) {

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const body = normalizeFullReportPayload(payload);

    const res = await AxiosInstance.post(API_REPORTS_BASE, body, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

const ReportsService = {
  generateReport,
};

export default ReportsService;
